import VueMultiselectExtended from '../inputs/multiselect';
import axios from 'axios';
import {formValidationMixin} from '../mixins/component-mixins';
import {globalActions} from '../../store/global-actions';
import {advertActions} from '../../store/advert-actions';
import {store} from '../../store/global-store';
import initAutocompleteComponent from '../map/autocomplete';
import initEditableInputComponent from '../inputs/editable-input';
import {Field, Form, defineRule, configure} from 'vee-validate';
import {required, regex} from '@vee-validate/rules';
import localizedValidationMessages from '../../shared/validation-localization/localization';

defineRule('required', required);
defineRule('regex', regex);

const advertModalBase = {
    computed: {
        model() {
            return null;
        },
        isModalOpened() {
            return null;
        },
    },
    methods: {
        getData() {
            return null;
        },
        submit() {
            this.close();
            this._sendRequest();
        },
        close() {
            this.isModalOpened = false;
        },
        getUrl() {
            return this.model.url;
        },
        _sendRequest() {
            axios.post(this.getUrl(), this.getData())
                .then(this._onSucceed)
                .catch(this._onError);
        },
        _onSucceed(response) {
            window.location = `${response.data}`;
        },
        _onError(result) {
            globalActions.handleAjaxErrors(result.response);
        },
    },
};

function initAdvertModalComponents(app) {
    configure({
        generateMessage: localizedValidationMessages(),
    });

    app.component('copyas-advert-modal', {
        extends: advertModalBase,
        template: '#copyas-advert-modal',
        mixins: [formValidationMixin],
        data() {
            return {
                isPricePeriodMultiSelectActive: false,
                modalHeader: null,
                disabledSubmit: false,
            };
        },
        components: {
            Multiselect: VueMultiselectExtended,
            VeeValidationFormContext: Form,
            ValidationField: Field,
        },
        computed: {
            model() {
                return store.state.advert.copyAsModel;
            },
            isModalOpened: {
                get() {
                    return store.state.advert.copyAsModalOpened;
                },
                set(value) {
                    if (value === false) {
                        advertActions.closeCopyAsModal();
                    }
                },
            },
            convertModel() {
                return this.model.convertModel ? this.model.convertModel : {offerType: 0};
            },
            validationModel() {
                return this.convertModel;
            },
            isInquiry() {
                return this.convertModel.isInquiry;
            },
        },
        watch: {
            'convertModel.offerType': {
                handler(newModel) {
                    if (newModel === this.convertModel.initialOfferType) {
                        this.convertModel.priceMin = this.convertModel.initialPriceMin;
                        this.convertModel.priceMax = this.convertModel.initialPriceMax;
                    }
                },
                deep: true,
            },
            isModalOpened(value) {
                if (value) {
                    let res = null;
                    const labelsList = this.$refs.labelsList;

                    if (this.convertModel && labelsList) {
                        if (this.convertModel.isInquiry) {
                            res = labelsList.getLabel('defaultHeader');
                        } else {
                            if (this.convertModel.isSale) {
                                res = labelsList.getLabel('sellHeader');
                            } else {
                                res = labelsList.getLabel('rentHeader');
                            }
                        }
                    }

                    this.modalHeader = res;
                }
            },
        },
        methods: {
            async submit() {
                this._clearErrors();
                this.disabledSubmit = true;

                const validator = this.$refs.validator;
                const result = await validator.validate();
                if (!result.valid) {
                    this._onError();
                    return;
                }

                this._sendRequest();
            },
            applyMinFiltration(priceList) {
                return this.convertModel.priceMax ?
                    priceList.filter((p) => parseFloat(p.value) <= parseFloat(this.convertModel.priceMax)) :
                    priceList;
            },
            applyMaxFiltration(priceList) {
                return this.convertModel.priceMin ?
                    priceList.filter((p) => parseFloat(p.value) >= parseFloat(this.convertModel.priceMin)) :
                    priceList;
            },
            addressUpdated(newAddress, newRadius) {
                this.convertModel.address = newAddress;
                this.convertModel.locationRadius = newRadius;
            },
            getData() {
                const data = {};
                Object.keys(this.convertModel).forEach((key) => {
                    if (this.convertModel[key] != null) {
                        data[key] = this.convertModel[key].value != null ? this.convertModel[key].value : this.convertModel[key];
                    }
                });
                return data;
            },
            changeOfferType() {
                this.convertModel.priceMin = null;
                this.convertModel.priceMax = null;
            },
            _onSucceed(response) {
                this.close();
                window.location = `${response.data}`;
            },
            _onError(errorResult) {
                this.disabledSubmit = false;
                this._handleValidationErrors(errorResult);
                this._scrollToValidationErrors();
            },
        },
    });

    initAutocompleteComponent(app);
    initEditableInputComponent(app);
};

export default initAdvertModalComponents;
